<script lang="ts">
  import { auth } from '$lib/stores/auth.svelte';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import Tooltip from './bootstrap/Tooltip.svelte';
  import { faUserGroup } from '@itdev-fortawesome/pro-solid-svg-icons/faUserGroup';

  interface Props {
    userId: number;
  }

  let { userId }: Props = $props();
</script>

<Tooltip disabled={!auth.canImpersonate(userId)} title="Impersonate User">
  <button
    disabled={!auth.canImpersonate(userId)}
    aria-label="Impersonate"
    class="btn impersonate-btn"
    onclick={e => {
      e.preventDefault();
      e.stopPropagation();
      auth.startAuthImpersonation(userId);
    }}
  >
    <FontAwesomeIcon icon={faUserGroup} />
  </button>
</Tooltip>

<style>
  .impersonate-btn {
    --bs-btn-color: var(--bs-primary);
    --bs-btn-padding-y: 0;
    --bs-btn-disabled-border-color: transparent;
  }
</style>
